import { render } from "./Example3.vue?vue&type=template&id=33a49fd8"
import script from "./Example3.vue?vue&type=script&lang=ts"
export * from "./Example3.vue?vue&type=script&lang=ts"
script.render = render

export default script